import { useEffect } from "react";

/**
 * 在 iframe / WebView 内嵌场景：滚动到文档底部时通知父窗口，用于解锁「同意」按钮。
 */
export function useLegalScrollReached(doc: "terms" | "privacy" | "legal") {
  useEffect(() => {
    const threshold = 16;
    let sent = false;
    function check() {
      if (sent) return;
      const el = document.documentElement;
      const body = document.body;
      const scrollTop = window.scrollY || el.scrollTop || body.scrollTop || 0;
      const viewport = window.innerHeight || el.clientHeight || 0;
      const height = Math.max(
        body.scrollHeight,
        el.scrollHeight,
        body.offsetHeight,
        el.offsetHeight,
        body.clientHeight,
        el.clientHeight,
      );
      if (scrollTop + viewport >= height - threshold) {
        sent = true;
        try {
          window.parent?.postMessage(
            { type: "mm_legal_reached", doc },
            window.location.origin,
          );
        } catch {
          // ignore
        }
      }
    }
    window.addEventListener("scroll", check, { passive: true });
    check();
    return () => window.removeEventListener("scroll", check);
  }, [doc]);
}
